/**
 *
 * Asynchronously loads the component for CreateSurveyModal
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'), {
  fallback: null,
});
